var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcNetwork = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start adornment"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 41440566"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 288",
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#191919",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 23",
    d: "M12 3V21",
    stroke: "#191919",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M21 12L3 12",
    stroke: "#191919",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 24",
    d: "M12.0001 3C6.03225 7.92352 5.42247 15.4308 12.0001 21",
    stroke: "#191919",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M11.9999 3C17.9677 7.92352 18.5775 15.4308 11.9999 21",
    stroke: "#191919",
    strokeWidth: 1.5
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcNetwork);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_network.510a464f7ef1158675af89ddca7c2c18.svg";